import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Shield, CheckCircle } from 'lucide-react';
import { OrderBumps } from './OrderBumps';
import { UpsellPopup } from './UpsellPopup';
export function UpdatedFinalCTA() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const [showUpsell, setShowUpsell] = useState(false);
  const basePrice = 14.0;
  const bump1Price = 6;
  const bump2Price = 6;
  const total = basePrice + (bump1 ? bump1Price : 0) + (bump2 ? bump2Price : 0);
  const originalBook = 136;
  const originalBump1 = 6;
  const originalBump2 = 6;
  const originalTotal = originalBook + (bump1 ? originalBump1 : 0) + (bump2 ? originalBump2 : 0);
  const getCheckoutUrl = () => {
    if (bump1 && bump2) return 'https://tucambiohoy.online/cart/43105451147377:1';
    if (bump1) return 'https://tucambiohoy.online/cart/43105447805041:1';
    if (bump2) return 'https://tucambiohoy.online/cart/43105448460401:1';
    return 'https://tucambiohoy.online/cart/43105421361265:1';
  };
  return <section id="comprar" className="py-10 px-4 bg-navy text-cream text-center" data-id="element-452">
      <div className="max-w-3xl mx-auto space-y-6" data-id="element-453">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-454">
          <p className="text-xl text-cream/80 font-light max-w-2xl mx-auto" data-id="element-455">
            No necesitas esperar a colapsar para empezar a cuidarte. <br data-id="element-456" />
            No necesitas "tener una mejor actitud" para estar mejor. <br data-id="element-457" />
            Necesitas un mapa. Y necesitas dejar de hacerlo solo(a).
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white/5 backdrop-blur-md p-6 rounded-2xl border border-white/10 inline-block w-full max-w-2xl" data-id="element-458">
          <p className="text-lg md:text-xl text-cream font-bold uppercase tracking-widest mb-2 animate-pulse" data-id="element-459">
            🔥 OFERTA ESPECIAL SOLO POR TIEMPO LIMITADO 🔥
          </p>
          <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-460">
            <AnimatePresence mode="wait" data-id="element-461">
              <motion.span key={total.toFixed(2)} initial={{
              opacity: 0,
              y: -10,
              scale: 1.1
            }} animate={{
              opacity: 1,
              y: 0,
              scale: 1
            }} exit={{
              opacity: 0,
              y: 10,
              scale: 0.9
            }} transition={{
              duration: 0.3
            }} className="text-5xl font-bold text-white" data-id="element-462">
                ${total.toFixed(2)}
              </motion.span>
            </AnimatePresence>
            <span className="text-xl text-cream/60" data-id="element-463">USD</span>
          </div>

          <a href={getCheckoutUrl()} target="_blank" rel="noopener noreferrer" onClick={e => {
          if (!bump1 && !bump2) {
            e.preventDefault();
            setShowUpsell(true);
            return;
          }
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'Cuando Todo Recae Sobre Ti + 5 Bonos',
              content_type: 'product',
              value: total,
              currency: 'USD'
            });
          }
        }} className="w-full bg-terracotta hover:bg-terracotta/90 text-white font-bold py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 flex items-center justify-center gap-2 text-lg" data-id="element-464">
            QUIERO ACCESO INMEDIATO
          </a>

          <div className="bg-cream/10 border border-cream/20 rounded-xl px-6 py-4 text-center max-w-md mx-auto my-6" data-id="element-465">
            <p className="text-lg font-serif font-bold text-cream" data-id="element-466">
              Garantía de 7 días
            </p>
            <p className="text-sm text-cream/70 mt-1" data-id="element-467">
              Léelo con calma. Si no sientes acompañamiento o un poquito de paz,
              te regreso tu dinero sin explicaciones.
            </p>
          </div>

          <OrderBumps bump1={bump1} bump2={bump2} setBump1={setBump1} setBump2={setBump2} data-id="element-468" />

          <p className="mt-4 text-sm text-cream/60 font-bold" data-id="element-469">
            Descarga inmediata · Empieza hoy · Solo necesitas tu celular
          </p>

          <div className="mt-6 bg-white rounded-xl overflow-hidden text-left shadow-sm" data-id="element-470">
            <div className="flex justify-between items-center px-5 py-3 border-b border-navy/10" data-id="element-471">
              <span className="text-sm text-navy/80" data-id="element-472">Libro + 5 Bonos</span>
              <span className="text-sm text-navy/40 line-through" data-id="element-473">
                ${originalBook.toFixed(2)}
              </span>
            </div>

            <AnimatePresence data-id="element-474">
              {bump1 && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.2
            }} className="overflow-hidden" data-id="element-475">
                  <div className="flex justify-between items-center px-5 py-3 border-b border-navy/10" data-id="element-476">
                    <span className="text-sm text-navy/80" data-id="element-477">
                      Kit de Emergencia Móvil
                    </span>
                    <span className="text-sm text-navy/80 font-medium" data-id="element-478">
                      +${bump1Price.toFixed(2)}
                    </span>
                  </div>
                </motion.div>}
            </AnimatePresence>

            <AnimatePresence data-id="element-479">
              {bump2 && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.2
            }} className="overflow-hidden" data-id="element-480">
                  <div className="flex justify-between items-center px-5 py-3 border-b border-navy/10" data-id="element-481">
                    <span className="text-sm text-navy/80" data-id="element-482">
                      Manual Conversaciones Incómodas
                    </span>
                    <span className="text-sm text-navy/80 font-medium" data-id="element-483">
                      +${bump2Price.toFixed(2)}
                    </span>
                  </div>
                </motion.div>}
            </AnimatePresence>

            <div className="flex justify-between items-center px-5 py-3 border-b border-navy/10" data-id="element-484">
              <span className="text-sm font-bold text-navy" data-id="element-485">Valor Total</span>
              <AnimatePresence mode="wait" data-id="element-486">
                <motion.span key={originalTotal.toFixed(2)} initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} exit={{
                opacity: 0
              }} className="text-sm text-navy/40 line-through" data-id="element-487">
                  ${originalTotal.toFixed(2)}
                </motion.span>
              </AnimatePresence>
            </div>

            <div className="flex justify-between items-center px-5 py-5 bg-terracotta/10" data-id="element-488">
              <span className="text-lg font-bold text-terracotta italic" data-id="element-489">
                Hoy pagas solo
              </span>
              <AnimatePresence mode="wait" data-id="element-490">
                <motion.span key={total.toFixed(2)} initial={{
                opacity: 0,
                scale: 1.1
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0,
                scale: 0.9
              }} transition={{
                duration: 0.3
              }} className="text-2xl font-bold text-terracotta" data-id="element-491">
                  ${total.toFixed(2)}
                </motion.span>
              </AnimatePresence>
            </div>
          </div>

          <a href={getCheckoutUrl()} target="_blank" rel="noopener noreferrer" onClick={e => {
          if (!bump1 && !bump2) {
            e.preventDefault();
            setShowUpsell(true);
            return;
          }
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: bump1 && bump2 ? 'Libro + Kit Emergencia + Manual Conversaciones' : bump1 ? 'Libro + Kit Emergencia' : bump2 ? 'Libro + Manual Conversaciones' : 'Cuando Todo Recae Sobre Ti + 5 Bonos',
              content_type: 'product',
              value: total,
              currency: 'USD'
            });
          }
        }} className="mt-6 w-full bg-terracotta hover:bg-terracotta/90 text-white font-bold py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 flex items-center justify-center gap-2 text-lg" data-id="element-492">
            <AnimatePresence mode="wait" data-id="element-493">
              <motion.span key={total.toFixed(2)} initial={{
              opacity: 0,
              y: -5
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: 5
            }} transition={{
              duration: 0.2
            }} data-id="element-494">
                COMPRAR AHORA — ${total.toFixed(2)} USD
              </motion.span>
            </AnimatePresence>
          </a>
        </motion.div>

        <div className="bg-cream/10 border border-cream/20 rounded-xl px-6 py-4 text-center max-w-md mx-auto mt-4" data-id="element-495">
          <p className="text-lg font-serif font-bold text-cream" data-id="element-496">
            Garantía sin riesgo
          </p>
          <p className="text-sm text-cream/70 mt-1" data-id="element-497">
            Tienes 7 días para probarlo. Si no te ayuda, recibes un reembolso
            completo. Tu bienestar es primero.
          </p>
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-lg font-serif italic text-cream/70" data-id="element-498">
          "Si estás listo(a) para dejar de sobrevivir y empezar a sostenerte,
          este libro es para ti."
        </motion.p>
      </div>
      <UpsellPopup isOpen={showUpsell} onClose={() => setShowUpsell(false)} data-id="element-499" />
    </section>;
}